<template>
    <div class="sh050" id="sh050">
        <!-- ご注文手続き -->
        <h2 class="">{{$t("common.labels.orderProcedure")}}</h2>
        <div class="sh050PayDetailMain">
            <div style="display:none;">
                <span id="pointsTouseThisTime_lbl">{{$t('common.labels.pointsTouseThisTime')}}</span>
                <span id="errorCashDelivery_lbl">{{$t('sh050.labels.errorCashDelivery')}}</span>
                <span id="errorPaymentSlip_lbl">{{$t('sh050.labels.errorPaymentSlip')}}</span>
                <span id="errorMailservice_lbl">{{$t('sh050.labels.errorMailservice')}}</span>
            </div>
            <div class="sh050PayDetail">
                <message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="SH050_PART"/>
                <br />
                <h4>{{$t("sh050.labels.choosePaymentMethod")}}</h4>
                <br />
                <p class="mb32">{{$t("sh050.labels.preferredPaymentMethod")}}</p>
                <table class="sh050PaytblPerson sh050Paytblmb32">
                    <!-- 支払い方法loop -->
                    <tbody v-for="(obj,index) in sh050SiharaiHohoKbnList" :key="index">
                        <template>
                            <!-- 代引き、が使えないパターン -->
                            <template v-if="sh050RespModel.daiNgFlg == 1 && obj.KEY == '2'">
                                <!-- 代引きの決済CDの表示をしない -->
                            </template>
                            <template v-else>
                                <tr>
                                    <th class="register-check w200">
                                        <input type="radio" :value="obj.KEY" name="siharai_hoho_kbn"
                                            :id="'_siharai_hoho_kbn_' + obj.KEY" :checked="obj.KEY == sh050RespModel.siharaiHohoKbn ? 'checked':''" @click="selectSiharaiHoho(obj.KEY)"/>
                                        <label :for="'_siharai_hoho_kbn_' + obj.KEY" onClick="">
                                            <strong>{{obj.VALUE}}</strong>
                                        </label>
                                    </th>
                                    <td>
                                        <!--決済方法のメッセージ -->
                                        <span v-html="descriptionInfo[obj.KEY]"></span>
                                    </td>
                                </tr>
                            </template>
                        </template>
                    </tbody>
                </table>
                <p class="sh050Paytblmb32" v-if="descriptionInfo[7] != ''">
                    <span v-html="descriptionInfo[7]"></span>
                </p>
                <ul class="button-column mb32">
                    <li>
                        <button @click="backPage" type="button">{{$t("common.buttons.backtothepreviouspage")}}</button>
                    </li>
                    <li>
                        <input type="submit" :value="$t('sh050.buttons.update')" :alt="$t('sh050.buttons.submit')" @click="submit" class="submit-button">
                    </li>
                </ul>
                <p class="sh050Paytblmb32">
                    {{$t('common.labels.note1')}}
                    <a @click="selectLink" :title="$t('common.labels.noteLink')" class="blank" target="_blank">{{$t('common.labels.noteLink')}}</a>
                    {{$t('common.labels.note2')}}
                </p>
            </div>
        </div>
    </div>
</template>
<script>

/* 
* Import libs and componnents
*/
import common from "assets/js/common";
import axios from "assets/js/request";
import EventBus from 'assets/js/eventBus';
import Message from 'components/MessageEcSite';
import SiteConstants from 'assets/const/SiteConstants.json';
import Constants from 'assets/const/Constants.json';
import InputNumber from "components/InputNumber";
import Loading from 'vue-loading-overlay';
export default {
    /* 
    * Name of component
    */
    name: "SH050ShopperPayDetails",
    props:{
        ptInitData: {
            type: Object,
            default: null,
        }
    },

    /* 
    * Get data from parent component
    */
    components:
    {
		EventBus,
		Message,
        Loading,
		InputNumber
    },
    data() {
        return {
            sh050DoInit:{
                descriptionInfo:{}
            },
            originSiharaiHohoKbn:null,
            originPointKbn:null,
            originPointUsed:null,
            sh050SiharaiHohoKbnList:{},
            amazonPayInfo:null,
            listIdErr:[],
            isLoading: false,
            sh050ReqModel:{},
			sh050RespModel:{
                pointKbn: '0',
                siharaiHohoKbn: null
            },
            descriptionInfo:[],
			SiteConstants: SiteConstants,
            Constants: Constants,
			SH050_PART:'sh050',
            listMessValid:[],
            mapMessValid:[],
            site: "",
            pointFlg : false,
            disable : false,
            background: "",
            inputPoint: 0,
            sh060 : {
                orderConfirmFlg : null
            }
        }
    },
    /*
    * 初期処理
    */
    mounted() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];
        _this.amazonPayInfo = sessionStorage['amazonPayInfo'];
        // 画面上部にAmazonPayボタンを表示(0だったら非表示)
        //if (_this.pt180Init.amazonPayFlg == '1') {
        // Dynamically load the Amazon Pay SDK script

        const script = document.createElement('script');
        script.src = 'https://static-fe.payments-amazon.com/checkout.js';
        script.async = true;
        document.head.appendChild(script);
        // Wait for the script to be loaded before rendering the button
        script.onload = () => {
            amazon.Pay.bindChangeAction('#changeButton1', {
                amazonCheckoutSessionId: sessionStorage['amazonCheckoutSessionId'],
                changeAction: 'changeAddress'
            });
        }
        //}
        if (_this.ptInitData){
            _this.$emit("event-loading", true);
            try {
                _this.sh050DoInit = _this.ptInitData;
                _this.sh050SiharaiHohoKbnList = _this.ptInitData.resultSiharaiHohoKbnList;

                _this.sh050RespModel = _this.ptInitData.reqModel;
                _this.inputPoint =  _this.ptInitData.reqModel.pointUsed;
                _this.originSiharaiHohoKbn = _this.sh050RespModel.siharaiHohoKbn;
                
                if (_this.sh050DoInit.siteFlg == 1) {
                    if(_this.sh050DoInit.seikyuKbn == 1) {
                        _this.sh050SiharaiHohoKbnList = _this.sh050SiharaiHohoKbnList.filter(kessaiCd => kessaiCd['KEY'] != "6");
                    } else if(_this.sh050DoInit.seikyuKbn == 2) {
                        _this.sh050SiharaiHohoKbnList = _this.sh050SiharaiHohoKbnList.filter(kessaiCd => kessaiCd['KEY'] != "6" && kessaiCd['KEY'] != "13");
                    } else if(_this.sh050DoInit.seikyuKbn == 0) { 
                        _this.sh050SiharaiHohoKbnList = _this.sh050SiharaiHohoKbnList.filter(kessaiCd => kessaiCd['KEY'] == '6');
                    } else{
                        _this.sh050SiharaiHohoKbnList = _this.sh050SiharaiHohoKbnList;
                    }
                }

                if (sessionStorage['amazonCheckoutSessionId'] != null) {
                    _this.sh050RespModel.siharaiHohoKbn = Constants.KESSAI_AMAZONPAY;
                }

                _this.descriptionInfo = _this.sh050DoInit.descriptionInfo;
                // ポイント利用オプションの場合表示をON
                if (_this.sh050RespModel.pointFlg == 1) {
                    _this.pointFlg = true;
                }
            } catch (error) {
                common.errorAPI(error);
            }finally{
                _this.$emit("event-loading", false);
            }
        }else{
            _this.$emit("event-loading", true);
            // eslint-disable-next-line
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH050 + _this.$UrlConstants.DO_INIT ,_this.sh050ReqModel).then(function(response) {
                _this.sh050DoInit = response.data;
                _this.sh050SiharaiHohoKbnList = response.data.resultSiharaiHohoKbnList;

                _this.sh050RespModel = response.data.reqModel;
                _this.inputPoint =  response.data.reqModel.pointUsed;
                _this.originSiharaiHohoKbn = _this.sh050RespModel.siharaiHohoKbn;

                if (_this.sh050DoInit.siteFlg == 1) {
                    if(_this.sh050DoInit.seikyuKbn == 1) {
                        _this.sh050SiharaiHohoKbnList = _this.sh050SiharaiHohoKbnList.filter(kessaiCd => kessaiCd['KEY'] != "6");
                    } else if(_this.sh050DoInit.seikyuKbn == 2) {
                        _this.sh050SiharaiHohoKbnList = _this.sh050SiharaiHohoKbnList.filter(kessaiCd => kessaiCd['KEY'] != "6" && kessaiCd['KEY'] != "13");
                    } else if(_this.sh050DoInit.seikyuKbn == 0) { 
                        _this.sh050SiharaiHohoKbnList = _this.sh050SiharaiHohoKbnList.filter(kessaiCd => kessaiCd['KEY'] == '6');
                    } else{
                        _this.sh050SiharaiHohoKbnList = _this.sh050SiharaiHohoKbnList;
                    }
                }
                // 初期値を最初の決済にする
                if (_this.sh050RespModel.siharaiHohoKbn == null || _this.sh050RespModel.siharaiHohoKbn == undefined 
                    || _this.sh050RespModel.siharaiHohoKbn == "993" || _this.sh050RespModel.siharaiHohoKbn == "" ) {
                    _this.sh050RespModel.siharaiHohoKbn = _this.sh050SiharaiHohoKbnList[0].KEY;
                }
                _this.descriptionInfo = _this.sh050DoInit.descriptionInfo;
                // ポイント利用オプションの場合表示をON
                if (_this.sh050RespModel.pointFlg == 1) {
                    _this.pointFlg = true;
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                common.errorAPI(error);
            });
        }
        
        // 複数届き先場合、NPK決済を非表示
        if (_this.sh050RespModel.tdkCnt > 1) {
            _this.sh050SiharaiHohoKbnList = _this.sh050SiharaiHohoKbnList.filter(item.KEY !== '83');
        }
        
        _this.originPointKbn = _this.sh050RespModel.pointKbn;
        _this.originPointUsed = _this.sh050RespModel.pointUsed;
        //Call method selectLink when selecting links on DataTable
        EventBus.$on("select-link", function(selectData) {
            _this.selectLink(selectData);
        });
    },
    methods: {
        /*
        * 内容確認画面へ
        */
     submit: async function(){
            var _this = this;
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.SH050_PART);
            if (_this.sh050RespModel.siharaiHohoKbn != '83') {
                _this.cancelAmazonPay();
            }
            _this.$emit("event-loading", true);
            await axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH050 + _this.$UrlConstants.DO_INPUT,_this.sh050RespModel).then(function(response) {
                if(response.data.status == "OK"){
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 22}});
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                if (_this.sh050RespModel.siharaiHohoKbn == "993") {
                    _this.sh050RespModel.siharaiHohoKbn = _this.sh050SiharaiHohoKbnList[0].KEY;
                }
                if(error != null && error != undefined){
                    _this.isModalShow = false;
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.SH050_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
                common.scrollTop();
            });
        },
        /*
        * Function selectLink
        */
        selectLink: function() {
            var _this = this;
            var pagedata = _this.$router.resolve({ query: {pageNo: 70}});
            window.open(pagedata.href,'_blank');
        },
		backPage: async  function(){
			var _this = this;
			_this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.SH050_PART);

            if (_this.sh060.orderConfirmFlg != 1) {
                // お届け先指定画面
                _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 19}});
            } else {
                // 注文確認画面
                _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 22}});
            }
		},

        // 支払い方法選択
		selectSiharaiHoho: async function(key){
			this.sh050RespModel.siharaiHohoKbn = key;
		},
        formatPrice: function(value){
            return common.formatPrice(value);
        },
        cancelAmazonPay: function() {
            sessionStorage.removeItem('amazonCheckoutSessionId'); 
            sessionStorage.removeItem('amazonPayInfo');
        }
    },
    /*
    * destroy eventbus of page before close page
    */
    beforeDestroy: function() {
        //close select-link eventbus
        EventBus.$off("select-link");
    },

    created() {
        var _this = this;
        var queryData = _this.$route.query;
        if (Object.keys(queryData).length > 0) {
            _this.sh060 = queryData;
        }
    }
}
</script>
